










































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'

import { projectVariables } from '../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

import AccountResourceItem1AccountDescription from './service-for-account-resource-item/account-resource-item-1-account-description.vue'
import AccountResourceItem2AccountStatistics from './service-for-account-resource-item/account-resource-item-2-account-statistics.vue'
import AccountResourceItem3TransactionStatistics from './service-for-account-resource-item/account-resource-item-3-transaction-statistics.vue'
import AccountResourceItem4YourGroups from './service-for-account-resource-item/account-resource-item-4-your-groups.vue'

import DigitalCurrency19AccountNotificationIndicator from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-19-account-notification-indicator.vue'

import { DIGITAL_CURRENCY_TRANSACTION_SERVICE_TYPE } from '../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-1-general/general-type-3-constants/constants-5-service-type'

const namespace = 'digitalCurrency'

@Component({
  components: {
    AccountResourceItem1AccountDescription,
    AccountResourceItem2AccountStatistics,
    AccountResourceItem3TransactionStatistics,
    AccountResourceItem4YourGroups,
    DigitalCurrency19AccountNotificationIndicator
  }
})
class YourAccountHelperComponents4AccountResourceItem extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean

  @Prop({ default: '' }) accountId?: string
  @Prop({ default: false }) isPublicAccountViewing?: boolean

  @Action('getDigitalCurrencyAccountNotifications', { namespace }) getDigitalCurrencyAccountNotifications?: any
  @Action('addEventListenerToDigitalCurrencyAccountNotifications', { namespace }) addEventListenerToDigitalCurrencyAccountNotifications?: any
  @Action('removeEventListenerFromDigitalCurrencyAccountNotifications', { namespace }) removeEventListenerFromDigitalCurrencyAccountNotifications?: any

  projectName: string = projectVariables.projectName

  // a list of the indexes of the panels that are open by default
  // [0, 2, 3, 1] means all 4 panels are expanded
  isExandedPanelList: number[] = []

  isOpenAccountDescription: number = 0
  isOpenAccountStatistics: number = 0
  isOpenTransactionStatistics: number = 0
  isOpenGroups: number = 0

  digitalCurrencyTransactionNotificationList: any[] = []
  digitalCurrencyTransactionNotificationEventListenerIdMap = null

  @Watch('accountId') async onUpdateAccountId () {
    await this.initializeAccountNotifications()
  }

  async mounted () {
    await this.initializeAccountNotifications()
  }

  async destroyed () {
    await this.addEventListenerToDigitalCurrencyAccountNotifications({
      digitalCurrencyAccountId: this.accountId,
      serviceType: DIGITAL_CURRENCY_TRANSACTION_SERVICE_TYPE,
      eventListenerIdMap: this.digitalCurrencyTransactionNotificationEventListenerIdMap
    })
  }

  async initializeAccountNotifications () {
    if (!this.accountId) {
      return
    }
    this.digitalCurrencyTransactionNotificationList = await this.getDigitalCurrencyAccountNotifications({
      digitalCurrencyAccountId: this.accountId,
      serviceType: DIGITAL_CURRENCY_TRANSACTION_SERVICE_TYPE
    })

    this.digitalCurrencyTransactionNotificationEventListenerIdMap = await this.addEventListenerToDigitalCurrencyAccountNotifications({
      digitalCurrencyAccountId: this.accountId,
      serviceType: DIGITAL_CURRENCY_TRANSACTION_SERVICE_TYPE,
      eventListenerCallbackFunction: (notificationList: any[]) => {
        this.digitalCurrencyTransactionNotificationList = notificationList || []
      }
    })
  }
}

export default YourAccountHelperComponents4AccountResourceItem

